import { css } from "styled-components";
export const OverflowContainerVertical = css `
  overflow-x: hidden;
  overflow-y: auto;
`;
